import React, { useState, useEffect } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Col, Row } from "reactstrap";
import { Fn_AddEditData, Fn_DisplayData } from "../../store/Functions";  
import { useDispatch } from "react-redux";
import { API_WEB_URLS } from "../../constants/constAPI";
import { useLocation, useNavigate } from "react-router-dom";

function AddTransportMaster() {
  const API_URL_SAVE = "TransportMaster/0/token";
    const API_URL_EDIT = API_WEB_URLS.MASTER + "/0/token/TransportEdit/Id"
  const [state, setState] = useState({
    id: 0,
    formData: {},
    isProgress: true,
  });

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {


    const Id = (location.state && location.state.Id) || 0

    if (Id > 0) {
      setState(prevState => ({
        ...prevState,
        id: Id,
      }))
      Fn_DisplayData(dispatch, setState, Id, API_URL_EDIT)
    }
  }, [dispatch, location.state])

  // Validation Schema
  const validationSchema = Yup.object({
    FromPlace: Yup.string().required("From Place is required"),
    ToPlace: Yup.string().required("To Place is required"),
    Quantity: Yup.number()
      .required("Quantity is required")
      .min(1, "Quantity must be at least 1"),
    Min: Yup.number()
      .required("Minimum value is required")
      .max(Yup.ref('Max'), "Min should be less than Max"),
    Max: Yup.number()
      .required("Maximum value is required")
      .min(Yup.ref('Min'), "Max should be greater than Min"),
  });

  const handleSubmit = async values => {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    console.log(values);
    let formData = new FormData();
    formData.append("FromPlace", values.FromPlace);
    formData.append("ToPlace", values.ToPlace);
    formData.append("Quantity", values.Quantity);
    formData.append("Min", values.Min);
    formData.append("Max", values.Max);
    formData.append("UserId", obj.uid);

    Fn_AddEditData(
      dispatch,
      setState,
      { arguList: { id: state.id, formData } },
      API_URL_SAVE,
      true,
      "memberid",
      navigate,
      '/TransportBid'
    );
  };

  return (
    <div className="page-content">
      <Formik
        initialValues={{
          ...state.formData,
          FromPlace: state.formData.FromPlace || "",
          ToPlace: state.formData.ToPlace || "",
          Quantity: state.formData.Quantity || "",
          Min: state.formData.Min || "",
          Max: state.formData.Max || "",
        }}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={values => handleSubmit(values)}
      >
        {() => (
          <Form className="form-horizontal">
            {/* From Place Field */}
            <Row>
              <Col lg="2">
                <label htmlFor="FromPlace" className="form-label">From Place</label>
              </Col>
              <Col lg="6" className="mb-3">
                <Field className="form-control" type="text" name="FromPlace" placeholder="Enter from place"/>
                <ErrorMessage name="FromPlace" component="div" className="text-danger" />
              </Col>
            </Row>

            {/* To Place Field */}
            <Row>
              <Col lg="2">
                <label htmlFor="ToPlace" className="form-label">To Place</label>
              </Col>
              <Col lg="6" className="mb-3">
                <Field className="form-control" type="text" name="ToPlace" placeholder="Enter to place"/>
                <ErrorMessage name="ToPlace" component="div" className="text-danger" />
              </Col>
            </Row>

            {/* Quantity Field */}
            <Row>
              <Col lg="2">
                <label htmlFor="Quantity" className="form-label">Quantity</label>
              </Col>
              <Col lg="6" className="mb-3">
                <Field className="form-control" type="number" name="Quantity" placeholder="Enter quantity"/>
                <ErrorMessage name="Quantity" component="div" className="text-danger" />
              </Col>
            </Row>

            {/* Min Field */}
            <Row>
              <Col lg="2">
                <label htmlFor="Min" className="form-label">Min</label>
              </Col>
              <Col lg="6" className="mb-3">
                <Field className="form-control" type="number" name="Min" placeholder="Enter minimum value"/>
                <ErrorMessage name="Min" component="div" className="text-danger" />
              </Col>
            </Row>

            {/* Max Field */}
            <Row>
              <Col lg="2">
                <label htmlFor="Max" className="form-label">Max</label>
              </Col>
              <Col lg="6" className="mb-3">
                <Field className="form-control" type="number" name="Max" placeholder="Enter maximum value"/>
                <ErrorMessage name="Max" component="div" className="text-danger" />
              </Col>
            </Row>

            {/* Submit Button */}
            <button type="submit" className="btn btn-primary btn-block">Submit</button>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default AddTransportMaster;
